import { Box, Stack, Typography } from "@mui/material";
import { useEffect } from "react";
import logout from "../../api/auth/logout";
import PageLoading from "../../components/layout/PageLoading";

export default function Logout() {
  useEffect(() => {
    logout(() => {
      console.log("Logged out");
      localStorage.clear();
      window.location = "/";
    });
  }, []);
  return (
    <Box>
      <Stack>
        <Typography variant="h5">Securely logging you out...</Typography>
      </Stack>
      <PageLoading />
    </Box>
  );
}